const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const calculateImageDimensions = ({ height, width }) => {
  const containerWidth = 104;
  const ratio = height / width;
  const imgWidth = containerWidth;
  const imgHeight = imgWidth * ratio;

  return { imgWidth, imgHeight };
};

const generateUploadModalCta = (onClick, children, disabled = false) => {
  return {
    onClick,
    children,
    disabled
  };
};

export { formatBytes, calculateImageDimensions, generateUploadModalCta };
